import type React from 'react';
import { useRef, useState } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';

interface Props {
  title: string;
  children?: React.ReactNode;
}

const Accordion: React.FC<Props> = ({ title, children }: Props) => {
  const [open, setOpen] = useState(false);
  const nodeRef = useRef<HTMLDivElement>(null);
  const onClick = () => {
    setOpen(!open);
  };
  const headerClass = classnames('accordion-header', { active: open });
  const contentClass = classnames('accordion-content', { active: open });
  let answerPart;
  if (open) {
    answerPart = (
      <CSSTransition nodeRef={nodeRef} appear timeout={500}>
        <div ref={nodeRef} className={contentClass}>
          {children as any}
        </div>
      </CSSTransition>
    );
  } else {
    answerPart = (
      <CSSTransition nodeRef={nodeRef} appear timeout={500}>
        <div ref={nodeRef} />
      </CSSTransition>
    );
  }
  return (
    <div className="accordion">
      <h2 className={headerClass} onClick={onClick}>
        {title}
      </h2>
      {answerPart}
    </div>
  );
};

export default Accordion;
